import { Grid } from "@mui/material";
import CustomFormField from "components/CustomFormField";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import PropTypes from "prop-types";
import { connect } from "react-redux";

const SubOrganizationForm = ({ formData, localizations, allOrganizations, isEditMode }) => {
  const {
    formField,
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    setFieldValue,
    setFieldTouched,
  } = formData;

  const {
    subOrganizationKey: { errorMsg: _subOrganizationKey, ...subOrganizationKeyRest },
    country: { errorMsg: _country, ...countryRest },
    city: { errorMsg: _city, ...cityRest },
    district: { errorMsg: _district, ...districtRest },
    address: { errorMsg: _address, ...addressRest },
    phone: { errorMsg: _phone, ...phoneRest },
    email: { errorMsg: _email, ...emailRest },
    organization: { errorMsg: _organization, ...organizationRest },
  } = formField;

  const {
    subOrganizationKey: subOrganizationKeyV,
    country: countryV,
    city: cityV,
    district: districtV,
    address: addressV,
    phone: phoneV,
    email: emailV,
    organization: organizationV,
  } = values;

  return (
    <>
      <SuiTypography variant="h5">
        {localizations?.SUB_ORGANIZATION_FORM_HEADER ?? "Şube Genel Detayları"}
      </SuiTypography>
      <SuiBox mt={1} mb={5}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={4}>
            <SuiBox
              sx={{
                cursor: isEditMode ? "not-allowed" : "default",
              }}
            >
              <CustomFormField
                {...organizationRest}
                options={
                  Array.isArray(allOrganizations) && allOrganizations.length > 0
                    ? allOrganizations.map((o) => ({
                        value: o.id,
                        label: o.organizationKey,
                      }))
                    : []
                }
                value={organizationV}
                error={errors.organization?.length > 0 && !(touched.organization !== true)}
                success={organizationV && !errors.organization}
                setFieldValue={setFieldValue}
                setFieldTouched={setFieldTouched}
                isDisabled={isEditMode}
              />
            </SuiBox>
          </Grid>
          <Grid item xs={12} lg={4}>
            <CustomFormField
              {...subOrganizationKeyRest}
              value={subOrganizationKeyV}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.subOrganizationKey?.length > 0 && touched.subOrganizationKey}
              success={subOrganizationKeyV.length > 0 && !errors.subOrganizationKey}
            />
          </Grid>
          <Grid item xs={12} lg={4}>
            <CustomFormField
              {...countryRest}
              value={countryV}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.country?.length > 0 && touched.country}
              success={countryV.length > 0 && !errors.country}
            />
          </Grid>
          <Grid item xs={12} lg={4}>
            <CustomFormField
              {...cityRest}
              value={cityV}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.city?.length > 0 && touched.city}
              success={cityV.length > 0 && !errors.city}
            />
          </Grid>
          <Grid item xs={12} lg={4}>
            <CustomFormField
              {...districtRest}
              value={districtV}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.district?.length > 0 && touched.district}
              success={districtV.length > 0 && !errors.district}
            />
          </Grid>
          <Grid item xs={12} lg={4}>
            <CustomFormField
              {...addressRest}
              value={addressV}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.address?.length > 0 && touched.address}
              success={addressV.length > 0 && !errors.address}
            />
          </Grid>
          <Grid item xs={12} lg={4}>
            <CustomFormField
              {...phoneRest}
              value={phoneV}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.phone?.length > 0 && touched.phone}
              success={phoneV.length > 0 && !errors.phone}
            />
          </Grid>
          <Grid item xs={12} lg={4}>
            <CustomFormField
              {...emailRest}
              value={emailV}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.email?.length > 0 && touched.email}
              success={emailV.length > 0 && !errors.email}
            />
          </Grid>
        </Grid>
      </SuiBox>
    </>
  );
};

SubOrganizationForm.defaultProps = {
  localizations: null,
  allOrganizations: null,
  isEditMode: false,
};

SubOrganizationForm.propTypes = {
  formData: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
  localizations: PropTypes.objectOf(PropTypes.any),
  allOrganizations: PropTypes.arrayOf(PropTypes.any),
  isEditMode: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  localizations: state.localization?.pairs,
});

export default connect(mapStateToProps, null)(SubOrganizationForm);
